import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { IoIosArrowDown } from 'react-icons/io'
class DropdownOpener extends Component {


  static propTypes = {
    children: PropTypes.node,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    caret: PropTypes.bool,
    onDropdownOpenStateChange: PropTypes.func,
    id: PropTypes.string,
    ButtonComponent: PropTypes.func,
    arrow: PropTypes.bool,
    clickToClose: PropTypes.bool
  }

  static contextTypes = {
    dropdownIsInside: PropTypes.bool
  }


  constructor(props) {
    super(props)
    this.state = { active: false }
    this.handleMouseUpOnBody = this.handleMouseUpOnBody.bind(this)
    this.handleMouseDown = this.handleMouseDown.bind(this)
    this.handleMouseUp = this.handleMouseUp.bind(this)
    this.handleMouseDownOnInner = this.handleMouseDownOnInner.bind(this)
  }

  componentDidMount() {
    document.body.addEventListener(
      'mouseup',
      this.handleMouseUpOnBody,
      false
    )
  }

  componentWillUnmount() {
    document.body.removeEventListener(
      'mouseup',
      this.handleMouseUpOnBody,
      false
    )
  }

  @autobind
  handleMouseUpOnBody(event) {

    // if
    // (obvious cases: when clicking the opener, this should not close it
    // immediately again)
    // 1) we don't have a ref to the opener element         OR
    // 2) that opener element contains the event target     OR
    // (clicking an element within the dropdown that has no
    // .dropdown-entry ancestor)
    // 3) the event target is no .dropdown-entry
    // => bail out
    if (
      !this.openerRef ||
      this.openerRef.contains(event.target) ||
      (event.target.closest('.geneva-dropdown') &&
        !event.target.closest('.dropdown-entry'))
      // (this.findClosest(e.target, '.geneva-dropdown') &&
      // !(this.findClosest(e.target, '.dropdown-entry')))
    ) {
      return
    }

    if (this.state.active) {
      event.preventDefault()
      event.stopPropagation()
      this.changeDropdownState({
        active: false
      })
    }

  }

  @autobind
  handleMouseDown(event) {
    event.nativeEvent.preventDefault()
    event.nativeEvent.stopImmediatePropagation()
    this.changeDropdownState({
      active: this.props.clickToClose ? !this.state.active : true
    })
  }

  @autobind
  handleMouseUp(event) {
    event.nativeEvent.preventDefault()
    event.nativeEvent.stopImmediatePropagation()
  }

  @autobind
  handleMouseDownOnInner(event) {
    event.nativeEvent.preventDefault()
    event.nativeEvent.stopImmediatePropagation()
  }

  changeDropdownState(state) {
    this.setState(state)
    if (this.props.onDropdownOpenStateChange) {
      this.props.onDropdownOpenStateChange({
        target: {
          open: state.active
        }
      })
    }
  }

  renderCaret() {
    return (
      <span className="geneva-caret">
      </span>)
  }
  renderArrow() {
    return (
      <span className="geneva-arrow">
        <IoIosArrowDown />
      </span>)
  }

  render() {

    const {
      children, disabled, caret, arrow, id, ButtonComponent
    } = this.props
    const { dropdownIsInside } = this.context
    const dataProps = Object.keys(this.props)
      .filter(prop => prop.indexOf('data-') > -1)
      .reduce((memo, prop) => {
        memo[prop] = this.props[prop]
        return memo
      }, {})

    if (dropdownIsInside || !ButtonComponent) {

      return (
        <a
          className={classNames(
            this.props.className,
            'button-dropdown'
          )}
          id={id}
          onMouseDown={this.handleMouseDownOnInner}
          disabled={disabled}
          {...dataProps}
        >
          {children} {arrow ? this.renderArrow() : this.renderCaret()}
        </a>)
    }

    return (
      <ButtonComponent
        // eslint-disable-next-line no-return-assign
        ref={ref => (this.openerRef = ref)}
        onClick={this.handleMouseUp}
        onMouseDown={this.handleMouseDown}
        onMouseUp={this.handleMouseUp}
        id={id}
        className={classNames(
          this.props.className || 'small button plain',
          'button-dropdown',
          { active: (this.state.active && !this.props.disabled) }
        )}
        disabled={disabled}
        {...dataProps}
      >
        {children}
        {caret !== false ? this.renderCaret() : null}
        {arrow ? this.renderArrow() : null}
      </ButtonComponent>)
  }
}

export { DropdownOpener as default }
